import { Component, Input, OnInit } from '@angular/core';
import { AgGridI } from 'src/app/shared/components/ag-grid/ag-grid.model';
import {AgGridDataModelTemplate} from '../../components/settings/template.model'
import { AgGridService } from 'src/app/shared/components/ag-grid/ag-grid.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AddEditcategoryComponent } from './Pop-ups/add-editcategory/add-editcategory.component';
import { AddTagsComponent } from './Pop-ups/add-tags/add-tags.component';
import { Button } from 'src/app/shared/model/enum';
import { Router } from '@angular/router';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  AgGridDataModelTemplate: AgGridI;
  @Input() rowData: any[];
  // dataModel: AgGridI;
  @Input() dataModel: any[];
  @Input() buttonName: string;
  enumButtonName          = Button;
  constructor( public agGridService: AgGridService,
    public storageService:StorageService,
    public modalService: NgbModal,
    public router: Router
  ) { }

  getRowStyle() {
    return { borderBottom: '1px solid rgba(139, 157, 170, 0.2)' };
  }

  ngOnInit(): void {
    this.AgGridDataModelTemplate = AgGridDataModelTemplate;
    //this.dataModel =  AgGridDataModelTemplate;
  
  }

  onGridReady(params) {
    this.agGridService.setGridApi(params.api);
    this.agGridService.setGridColumnApi(params.columnApi);
    var colState = this.storageService.retrieve('');
    if (!colState) {
      return;
    }
    this.agGridService.getGridColumnApi().applyColumnState({
      state: colState,
      applyOrder: true,
    });
  }


  TagPopup(){
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "editMailinglist",
    };
    const modalRef = this.modalService.open(AddTagsComponent, modalOption);
    modalRef.componentInstance.headingsNames = this.buttonName;
    // if(this.buttonName == 'Add Company'){
    //   // this.companiesService.nextTab.next(false)
    // }
  }    
  
  
  AddCategoryPopUp() {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "editMailinglist",
    };
    const modalRef = this.modalService.open(AddEditcategoryComponent, modalOption);
    modalRef.componentInstance.headingsNames = this.buttonName;
    // if(this.buttonName == 'Add Company'){
    //   // this.companiesService.nextTab.next(false)
    // }
  }  


  openNewTemplate() {
    //this.router.navigate(['./smxquilleditor']);
    this.router.navigate(['./smxeditor']);
   
    //this.router.navigateByUrl('/smxquilleditor')
  }

  onEditIconClick(params ) {
    console.log(params);
  }


  onDeleteIconClick(params) {

  }
  


}
